import axios from 'axios'
import { BUSCAR_IMPOSTOS_EMPRESA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarImpostosEmpresa (codigoEmpresa) {
  const url = `${URL}/imposto-empresa/empresa/${codigoEmpresa}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_IMPOSTOS_EMPRESA,
        payload: response

      })
  );
}
